import { render, staticRenderFns } from "./Logged.vue?vue&type=template&id=354883e5&scoped=true&"
var script = {}
import style0 from "./Logged.vue?vue&type=style&index=0&id=354883e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354883e5",
  null
  
)

export default component.exports